import React, { useState, useEffect, useRef } from 'react'

import axios from 'axios'
import CryptoJS from 'crypto-js'

import Settings from 'settings'
import { getLanguage } from '../../utils/Locale'
import { getIncludedDays } from '../../utils/Date'

import Checkbox from '../../components/Checkbox'
import Loader from '../../components/Loader/Loader'
import PicturePicker from '../../components/PicturePicker/PicturePicker'
import { ActionLink, FormGroup, KioskSelection } from './MenuSettings'

import { ButtonDiv, Button, Separator, LineWrapper } from './style'
import { computeWinrestHash } from '../../utils/Crypto'
import { getUrlVars } from '../../utils/UrlUtils'
import { WINREST_API_BASE_URL } from '../../utils/Config'

const WinrestForm2 = props => {
    const [sites, setSites] = useState()
    const [guestTypes, setGuestTypes] = useState()
    const [mealTypes, setMealTypes] = useState()
    const [pointOfSales, setPointOfSales] = useState()

    const [baseUrl, setBaseUrl] = useState(
        props.defaultValues ? props.defaultValues.baseUrl : ''
    )
    const [siteId, setSiteId] = useState(
        props.defaultValues ? props.defaultValues.siteId : ''
    )
    const [pointOfSaleId, setPointOfSaleId] = useState()
    const [guestTypeId, setGuestTypeId] = useState()
    const [mealTypeId, setMealTypeId] = useState()
    const [menuId, setMenuId] = useState()

    const [recipeTypes, setRecipeTypes] = useState()
    const [defaultKiosks, setDefaultKiosks] = useState()

    const [currentPointOfSale, setCurrentPointOfSale] = useState()
    const [allRecipes, setAllRecipes] = useState([])
    const [selectedRecipeTypes, setSelectedRecipeTypes] = useState([])

    const [loading, setLoading] = useState(false)
    const [currentRecipePicture, setCurrentRecipePicture] = useState(false)

    const [pictures, setPictures] = useState(
        localStorage.getItem('winrest-recipes-pictures')
            ? JSON.parse(localStorage.getItem('winrest-recipes-pictures'))
            : {}
    )

    const prevDayCount = useRef()

    const fetchInformations = async () => {
        if (!baseUrl) {
            return
        }

        setSites()
        setGuestTypes()
        setMealTypes()
        setPointOfSales()
        setPointOfSaleId()
        setGuestTypeId()
        setMealTypeId()
        setMenuId()

        const fetch = async () => {
            setLoading(true)
            try {
                // value should be like wrfr.newrest.eu.
                const countryCode = baseUrl.split('.')[0].replace('wr', '')

                const path = 'Information'
                const url = `${WINREST_API_BASE_URL}/${countryCode}/${path}`
                // const informationUrl = baseUrl.startsWith('api')
                //     ? 'displayeat/fr/Information'
                //     : `service/v1/Information`

                //const url = `${value}/${informationUrl}`

                const result = await axios.get(url, {
                    headers: { bearer: computeWinrestHash(path) },
                })

                setSites(result.data.Sites)
                setGuestTypes(result.data.TypeGuests)
                setMealTypes(result.data.TypeMeals)
                setLoading(false)
            } catch (e) {
                console.error('Error fetching Winrest informations', e)
                setLoading(false)
                return
            }
        }
        fetch()
    }

    const handleSetBaseUrl = e => {
        if (e.key === 'Enter') {
            fetchInformations()
        }
    }

    useEffect(() => {
        if (getUrlVars().utm_source === 'winrest') {
            fetchInformations()
        }
    }, [baseUrl])

    useEffect(() => {
        const fetch = async () => {
            if (!siteId || !props.date) {
                return
            }
            setLoading(true)

            const countryCode = baseUrl.split('.')[0].replace('wr', '')

            const path = `sites/${siteId}/pointsOfSale/${props.date}`
            const url = `${WINREST_API_BASE_URL}/${countryCode}/${path}`



            const result = await axios.get(url, {
                headers: { bearer: computeWinrestHash(path) },
            })

            let values = null
            if (result.data) {
                values = result.data.reduce((res, data) => {
                    const byGuestTypes = groupBy(data.menus, 'guestTypeId')
                    const byMealTypes = groupBy(data.menus, 'mealTypeId')
                    res.push({ ...data, byGuestTypes, byMealTypes })
                    return res
                }, [])
            }

            setPointOfSales(values)

            if (!pointOfSaleId) {
                setPointOfSaleId(
                    props.defaultValues ? props.defaultValues.pointOfSaleId : ''
                )
            }

            if (!guestTypes) {
                setGuestTypeId(
                    props.defaultValues ? props.defaultValues.guestTypeId : ''
                )
            }

            if (!mealTypeId) {
                setMealTypeId(
                    props.defaultValues ? props.defaultValues.mealTypeId : ''
                )
            }
            if (!menuId) {
                setMenuId(props.defaultValues ? props.defaultValues.menuId : '')
            }

            setLoading(false)
        }

        fetch()
    }, [siteId, props.date])

    useEffect(() => {
        if (!pointOfSaleId || !pointOfSales) {
            return
        }
        setCurrentPointOfSale(pointOfSales.find(_ => _.id == pointOfSaleId))
    }, [pointOfSaleId])

    useEffect(() => {
        if (!pointOfSales) {
            return
        }

        updateRecipes(menuId)
    }, [pointOfSales])

    useEffect(() => {
        if (!menuId) {
            props.handleChange(null, 'winrest2', {
                kiosks: null,
            })
            return
        }

        updateRecipes(menuId)
    }, [menuId])

    useEffect(() => {
        if (!selectedRecipeTypes) {
            return
        }
        props.handleChange(null, 'winrest2', {
            selectedRecipeTypes,
        })
    }, [selectedRecipeTypes])

    useEffect(() => {
        // use previous value to prevent fetch on first render
        if (props.dayCount < 1 || !prevDayCount.current) {
            return
        }
        const includedDays = getIncludedDays(
            props.date,
            props.startDay,
            props.dayCount,
            props.language,
            props.displayMode,
            props.excludedDays
        )

        const fetch = async () => {
            setLoading(true)
            const urls = []
            for (let i = 0; i < includedDays.length; i++) {
                const d = includedDays[i].format('YYYY-MM-DD')
                const countryCode = baseUrl.split('.')[0].replace('wr', '')
                const path = `sites/${siteId}/pointsOfSale/${d}`
                const url = WINREST_API_BASE_URL + `/${countryCode}/${path}`
                const key = computeWinrestHash(path)
                urls.push({
                    key,
                    url: `${url}?deliveryId=${pointOfSaleId}&menuId=${menuId}`,
                })
            }

            // const values = await Promise.all(
            //     urls.map(_ =>
            //         axios.get(`https://${baseUrl}/${_.url}`, {
            //             headers: { bearer: _.key },
            //         })
            //     )
            // )

            const values = []
            for (let i = 0; i < urls.length; i++) {
                const value = await axios.get(
                    `${urls[i].url}`,
                    {
                        headers: { bearer: urls[i].key },
                    }
                )
                values.push(value)
            }

            const menus = []
            const kiosks = []
            let allRecipeTypes = []
            let allRecipes = []
            for (let i = 0; i < values.length; i++) {
                if (!values[i].data || !values[i].data[0].menus) {
                    continue
                }
                const menu = values[i].data[0].menus[0]
                kiosks.push({
                    date: menu.date.slice(0, 10),
                    currency: menu.currency,
                    recipes: {
                        ...groupBy(menu.recipes, 'recipeTypeName'),
                        ...groupBy(menu.recipes, 'defaultKiosk'),
                    },
                })

                menu.recipes.forEach(_ => {
                    if (!allRecipeTypes.includes(_.recipeTypeName)) {
                        allRecipeTypes.push(_.recipeTypeName)
                    }
                })

                const recipesCopy = []
                menu.recipes.forEach(_ =>
                    recipesCopy.push(Object.assign({}, _))
                )
                const groupedByDefaultKiosk = groupBy(
                    recipesCopy,
                    'defaultKiosk'
                )
                const defaultKiosks = Object.keys(groupedByDefaultKiosk).map(
                    _ => {
                        return groupedByDefaultKiosk[_].map(a => {
                            a.recipeTypeName = a.defaultKiosk
                            return a
                        })
                    }
                )
                const defaultKiosksFlattenArray = []
                defaultKiosks.forEach(_ => {
                    _.forEach(a => defaultKiosksFlattenArray.push(a))
                })
                menu = {
                    ...menu,
                    recipes: menu.recipes.concat(defaultKiosksFlattenArray),
                }

                menus.push(menu)

                allRecipes = [...allRecipes, ...menu.recipes]
            }

            setAllRecipes(allRecipes)

            if (allRecipes && allRecipes.length > 0) {
                // allRecipeTypes = sortRecipeTypesByRecipeTypeOrder(
                //     allRecipeTypes,
                //     groupBy(allRecipes, 'recipeTypeName')
                // )
                // allRecipeTypes = [
                //     ...allRecipeTypes,
                //     ...Object.keys(groupBy(allRecipes, 'recipeTypeName'))
                // ]
            }

            // Put recipes grouped by kiosk at the end
            // allRecipeTypes = [
            //     ...allRecipeTypes,
            //     ...Object.keys(groupBy(allRecipes, 'defaultKiosk')),
            // ]

            const _defaultKiosks = Object.keys(
                groupBy(allRecipes, 'defaultKiosk')
            )
            setRecipeTypes(allRecipeTypes)
            setDefaultKiosks(_defaultKiosks)
            const _selectedRecipeTypes = allRecipeTypes.filter(_ =>
                selectedRecipeTypes.includes(_)
            )
            setSelectedRecipeTypes(_selectedRecipeTypes)
            setDefaultRecipePictures([...allRecipeTypes, ..._defaultKiosks])

            props.handleChange(null, 'winrest2', {
                kiosks,
                menus,
                baseUrl,
                siteId,
                pointOfSaleId,
                guestTypeId,
                mealTypeId,
                menuId,
                selectedRecipeTypes: _selectedRecipeTypes,
            })
            setLoading(false)
        }
        fetch()
    }, [props.dayCount, props.startDay, props.excludedDays])

    useEffect(() => {
        prevDayCount.current = props.dayCount
    }, [props.dayCount])

    useEffect(() => {
        props.handleChange(null, 'winrest2', {
            pictures,
        })
    }, [pictures])

    useEffect(() => {
        if (props.displayMode === 'week' && props.startDay === 'today') {
            props.handleChange({
                target: { name: 'startDay', type: 'select', value: 'monday' },
            })
        }
    }, [props.displayMode])

    const updateRecipes = menuId => {
        if (!pointOfSales) {
            return
        }
        const currentPointOfSale = pointOfSales.find(_ => _.id == pointOfSaleId)
        if (!currentPointOfSale) {
            return
        }

        const menu = currentPointOfSale.menus.find(_ => _.id == menuId)
        if (!menu) {
            return
        }

        setAllRecipes([...menu.recipes])

        const recipesByType = groupBy(menu.recipes, 'recipeTypeName')
        let recipeTypes = Object.keys(recipesByType)

        // if (recipeTypes && recipeTypes.length > 0) {
        //     recipeTypes = sortRecipeTypesByRecipeTypeOrder(
        //         recipeTypes,
        //         recipesByType
        //     )
        // }

        // Put recipes grouped by kiosk at the end
        // recipeTypes = [
        //     ...recipeTypes,
        //     ...Object.keys(groupBy(menu.recipes, 'defaultKiosk')),
        // ]

        const _defaultKiosks = Object.keys(
            groupBy(menu.recipes, 'defaultKiosk')
        )
        setRecipeTypes(recipeTypes)
        setDefaultKiosks(_defaultKiosks)
        const _selectedRecipeTypes = recipeTypes.filter(_ => _ !== 'None')
        setSelectedRecipeTypes(_defaultKiosks)
        setDefaultRecipePictures([...recipeTypes, ..._defaultKiosks])

        props.handleChange(null, 'winrest2', {
            kiosks: [
                {
                    date: props.date,
                    currency: menu.currency,
                    recipes: {
                        ...recipesByType,
                        ...groupBy(menu.recipes, 'defaultKiosk'),
                    },
                },
            ],
            baseUrl,
            siteId,
            pointOfSaleId,
            guestTypeId,
            mealTypeId,
            menuId,
            selectedRecipeTypes: _selectedRecipeTypes,
        })
    }

    const sortRecipeTypesByRecipeTypeOrder = (recipeTypesP, recipesByTypeP) => {
        const recipesByType =
            recipesByTypeP || groupBy(allRecipes, 'recipeTypeName')
        if (!recipesByType || recipesByType == []) return

        let recipeTypes = recipeTypesP || Object.keys(recipesByType)
        if (!recipeTypes || recipeTypes == []) return

        recipeTypes.sort((a, b) => {
            if (!recipesByType[a] || !recipesByType[a][0]) return 1
            if (!recipesByType[b] || !recipesByType[b][0]) return -1

            return (
                recipesByType[a][0].recipeTypeOrder -
                recipesByType[b][0].recipeTypeOrder
            )
        })

        return recipeTypes
    }

    const handleChangeSelectedRecipeTypes = e => {
        const name = e.target.name
        const value = e.target.checked

        if (value) {
            setSelectedRecipeTypes(
                //sortRecipeTypesByRecipeTypeOrder([...selectedRecipeTypes, name])
                [...selectedRecipeTypes, name]
            )
        } else {
            setSelectedRecipeTypes(selectedRecipeTypes.filter(_ => _ !== name))
        }

        if (
            value &&
            (!pictures[props.concept] || !pictures[props.concept][name])
        ) {
            setCurrentRecipePicture(name)
        }
    }

    const handleChangeSelectedDefaultKiosk = e => {
        const name = e.target.name
        const value = e.target.checked

        if (value) {
            setSelectedRecipeTypes(
                //sortRecipeTypesByRecipeTypeOrder([...selectedRecipeTypes, name])
                [...selectedRecipeTypes, name]
            )
        } else {
            setSelectedRecipeTypes(selectedRecipeTypes.filter(_ => _ !== name))
        }
    }

    const handlePictureChange = e => {
        const value = e.target.name
        if (value.indexOf('-') === -1 || value.indexOf('_') === -1) {
            return
        }

        const values = [
            value.slice(0, value.lastIndexOf('-')),
            value.slice(value.lastIndexOf('-') + 1, value.length),
        ]
        const recipe = values[0].split('_')[1]
        const picture = values[1]
        const concept = props.concept

        setPictures({
            ...pictures,
            [concept]: {
                ...(pictures[concept] || {}),
                [recipe]: picture,
            },
        })

        props.handleChange(e)
    }

    const groupBy = (xs, key) => {
        return xs.reduce(function(rv, x) {
            if (x[key] === '') return rv
            ;(rv[x[key]] = rv[x[key]] || []).push(x)
            return rv
        }, {})
    }

    const defaultTitle =
        Settings.translations[getLanguage(props.language)].today

    const setDefaultRecipePictures = recipeTypes => {
        if (pictures && props.concept && pictures[props.concept]) {
            recipeTypes.forEach(r => {
                if (!pictures[props.concept][r]) {
                    pictures[props.concept][r] = r
                }
            })
        } else {
            if (!pictures[props.concept]) {
                pictures[props.concept] = {}
            }

            recipeTypes.forEach(r => {
                pictures[props.concept][r] = r
            })
        }
    }

    return (
        <>
            <FormGroup>
                <label>Winrest URL:</label>
                <input
                    value={baseUrl}
                    name="winrestURL"
                    onBlur={e => setBaseUrl(e.target.value)}
                    onChange={e => setBaseUrl(e.target.value)}
                    onKeyUp={handleSetBaseUrl}
                />
                <div />
                <small>ex: wrfr.newrest.eu </small>
            </FormGroup>
            {sites && (
                <>
                    <FormGroup>
                        <label>Site:</label>
                        <select
                            name="siteId"
                            value={siteId}
                            onChange={e => setSiteId(e.target.value)}
                        >
                            <option value="">CHOOSE A SITE</option>
                            {sites.map((singleSite, index) => (
                                <option value={singleSite.id} key={index}>
                                    {singleSite.name}
                                </option>
                            ))}
                        </select>
                    </FormGroup>
                    <FormGroup>
                        <label>Concept:</label>
                        <select
                            name="concept"
                            value={props.concept}
                            onChange={props.handleChange}
                        >
                            {props.concepts.map((concept, index) => (
                                <option value={concept.code} key={index}>
                                    {concept.name}
                                </option>
                            ))}
                        </select>
                    </FormGroup>
                    <FormGroup>
                        <label>Date:</label>
                        <input
                            name="date"
                            type="date"
                            value={props.date}
                            onChange={props.handleChange}
                            disabled={props.forceToday}
                        />
                    </FormGroup>
                    <FormGroup title="The link will be generated with the {today} token to automatically display the menu of the current day">
                        <label>Current date:</label>
                        <div>
                            <Checkbox
                                name="forceToday"
                                type="checkbox"
                                value={props.forceToday}
                                checked={props.forceToday}
                                onAction={props.handleChange}
                            />
                        </div>
                    </FormGroup>
                </>
            )}

            {pointOfSales && (
                <FormGroup>
                    <label>Point Of Sale:</label>
                    <select
                        name="pointOfSaleSlug"
                        value={pointOfSaleId}
                        onChange={e => setPointOfSaleId(e.target.value)}
                    >
                        <option value="">CHOOSE A DELIVERY</option>
                        {pointOfSales.map((pointOfSale, index) => (
                            <option value={pointOfSale.id} key={index}>
                                {pointOfSale.name}
                            </option>
                        ))}
                    </select>
                </FormGroup>
            )}

            {pointOfSales &&
                guestTypes &&
                mealTypes &&
                pointOfSaleId &&
                currentPointOfSale && (
                    <>
                        <FormGroup>
                            <label>Guest Type:</label>
                            <select
                                name="guestTypeSlug"
                                value={guestTypeId}
                                onChange={e => setGuestTypeId(e.target.value)}
                            >
                                <option value="">CHOOSE A GUEST TYPE</option>
                                {Object.keys(
                                    currentPointOfSale.byGuestTypes
                                ).map((id, index) => (
                                    <option value={id} key={index}>
                                        {guestTypes.find(_ => _.id == id).name}
                                    </option>
                                ))}
                            </select>
                        </FormGroup>
                        <FormGroup>
                            <label>Meal Type:</label>
                            <select
                                name="mealTypeSlug"
                                value={mealTypeId}
                                onChange={e => setMealTypeId(e.target.value)}
                            >
                                <option value="">CHOOSE A MEAL TYPE</option>
                                {Object.keys(
                                    currentPointOfSale.byMealTypes
                                ).map((id, index) => (
                                    <option value={id} key={index}>
                                        {mealTypes.find(_ => _.id == id).name}
                                    </option>
                                ))}
                            </select>
                        </FormGroup>
                        {guestTypeId && mealTypeId && (
                            <FormGroup>
                                <label>Menu:</label>
                                <select
                                    name="menuSlug"
                                    value={menuId}
                                    onChange={e => setMenuId(e.target.value)}
                                >
                                    <option value="">CHOOSE A MENU</option>
                                    {currentPointOfSale.menus
                                        .filter(
                                            menu =>
                                                menu.guestTypeId ==
                                                    guestTypeId &&
                                                menu.mealTypeId == mealTypeId
                                        )
                                        .map((menu, index) => (
                                            <option value={menu.id} key={index}>
                                                {menu.name}
                                            </option>
                                        ))}
                                </select>
                            </FormGroup>
                        )}

                        {recipeTypes && (
                            <>
                                <label>Recipe Type:</label>
                                <KioskSelection nogrid>
                                    {props.concept && (
                                        <PicturePicker
                                            concept={props.concept}
                                            handleChange={handlePictureChange}
                                            open={currentRecipePicture}
                                            useCommercialName={
                                                props.useCommercialName
                                            }
                                            close={() =>
                                                setCurrentRecipePicture(null)
                                            }
                                        />
                                    )}
                                    {/* {Object.keys(recipes).map((name, index) => ( */}
                                    {recipeTypes.map((name, index) => (
                                        <LineWrapper key={index}>
                                            <div>
                                                <Checkbox
                                                    name={name}
                                                    type="checkbox"
                                                    checked={selectedRecipeTypes.includes(
                                                        name
                                                    )}
                                                    onAction={e =>
                                                        handleChangeSelectedRecipeTypes(
                                                            e
                                                        )
                                                    }
                                                    label={name}
                                                />
                                            </div>
                                            {selectedRecipeTypes.includes(
                                                name
                                            ) && (
                                                <Button
                                                    onClick={() =>
                                                        setCurrentRecipePicture(
                                                            name
                                                        )
                                                    }
                                                >
                                                    Modify
                                                </Button>
                                            )}
                                        </LineWrapper>
                                    ))}
                                </KioskSelection>
                            </>
                        )}

                        {defaultKiosks && (
                            <>
                                <label>Default kiosks:</label>
                                <KioskSelection nogrid>
                                    {defaultKiosks.map((name, index) => (
                                        <LineWrapper key={index}>
                                            <div>
                                                <Checkbox
                                                    name={name}
                                                    type="checkbox"
                                                    checked={selectedRecipeTypes.includes(
                                                        name
                                                    )}
                                                    onAction={e =>
                                                        handleChangeSelectedDefaultKiosk(
                                                            e
                                                        )
                                                    }
                                                    label={
                                                        name == 'null'
                                                            ? 'N/A'
                                                            : name
                                                    }
                                                />
                                            </div>
                                        </LineWrapper>
                                    ))}
                                </KioskSelection>
                            </>
                        )}
                    </>
                )}

            {menuId && (
                <>
                    <FormGroup>
                        <label>Language:</label>
                        <select
                            name="uiLanguage"
                            value={props.uiLanguage}
                            onChange={props.handleChange}
                        >
                            <option value="en">English</option>
                            <option value="es">Español</option>
                            <option value="fr">Français</option>
                            <option value="tr">Türk</option>
                            <option value="pt">Português</option>
                            <option value="el">Greek</option>
                        </select>
                    </FormGroup>
                    <FormGroup>
                        <label>Recipe name:</label>
                        <select
                            name="winrestLanguage"
                            value={props.winrestLanguage}
                            onChange={props.handleChange}
                        >
                            <option value="commercialName1">
                                COMMERCIAL NAME 1
                            </option>
                            <option value="commercialName2">
                                COMMERCIAL NAME 2
                            </option>
                        </select>
                    </FormGroup>
                    <FormGroup>
                        <label>Title:</label>
                        <input
                            name="title"
                            type="title"
                            value={props.title || ''}
                            onChange={props.handleChange}
                            placeholder={defaultTitle}
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>Sub title:</label>
                        <input
                            name="subtitle"
                            type="subtitle"
                            value={props.subtitle || ''}
                            onChange={props.handleChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>hide menu price:</label>
                        <div>
                            <Checkbox
                                name="hideMenuPrice"
                                type="checkbox"
                                checked={props.hideMenuPrice}
                                onAction={props.handleChange}
                            />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <label>Hide recipe points:</label>
                        <div>
                            <Checkbox
                                name="hideRecipePoints"
                                type="checkbox"
                                checked={props.hideRecipePoints}
                                onAction={props.handleChange}
                            />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <label>hide calories:</label>
                        <div>
                            <Checkbox
                                name="hideEnergyKcal"
                                type="checkbox"
                                checked={props.hideEnergyKcal}
                                onAction={props.handleChange}
                            />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <label>calories by portion:</label>
                        <div>
                            <Checkbox
                                name="showEnergyKcalByPortion"
                                type="checkbox"
                                checked={props.showEnergyKcalByPortion}
                                onAction={props.handleChange}
                            />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <label>USE RECIPE TYPE NAME:</label>
                        <div>
                            <Checkbox
                                name="useCommercialName"
                                type="checkbox"
                                checked={props.useCommercialName}
                                onAction={props.handleChange}
                            />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <label>HIDE COMPOSITION:</label>
                        <div>
                            <Checkbox
                                name="hideComposition"
                                type="checkbox"
                                checked={props.hideComposition}
                                onAction={props.handleChange}
                            />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <label>HIDE LABELS:</label>
                        <div>
                            <Checkbox
                                name="hideLabels"
                                type="checkbox"
                                checked={props.hideLabels}
                                onAction={props.handleChange}
                            />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <label>HIDE INTOLERENCES:</label>
                        <div>
                            <Checkbox
                                name="hideIntolerences"
                                type="checkbox"
                                checked={props.hideIntolerences}
                                onAction={props.handleChange}
                            />
                        </div>
                    </FormGroup>
                    {props.displayMode === 'kiosk' && (
                        <FormGroup>
                            <label>Duo Kiosk:</label>
                            <div>
                                <Checkbox
                                    name="isDuoKiosk"
                                    type="checkbox"
                                    checked={props.isDuoKiosk}
                                    onAction={props.handleChange}
                                />
                            </div>
                        </FormGroup>
                    )}

                    <Separator />
                    <FormGroup>
                        <label>Day count:</label>
                        <input
                            name="dayCount"
                            type="number"
                            value={props.dayCount}
                            onChange={loading ? null : props.handleChange}
                            disabled={props.displayMode === 'print' || loading}
                            min="1"
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>Start day:</label>
                        <select
                            name="startDay"
                            value={props.startDay}
                            onChange={props.handleChange}
                        >
                            {props.days.map((day, index) => (
                                <option
                                    value={day}
                                    key={index}
                                    disabled={
                                        props.displayMode === 'week' &&
                                        day === 'today'
                                    }
                                >
                                    {day}
                                </option>
                            ))}
                        </select>
                    </FormGroup>
                    {props.dayCount > 1 && (
                        <FormGroup>
                            <label>Excluded days:</label>
                            <select
                                name="excludedDays"
                                style={{ height: '120px' }}
                                multiple
                                onChange={props.setExcludedDays}
                            >
                                <option value="1">monday</option>
                                <option value="2">tuesday</option>
                                <option value="3">wednesday</option>
                                <option value="4">thurday</option>
                                <option value="5">friday</option>
                                <option value="6">saturday</option>
                                <option value="0">sunday</option>
                            </select>
                        </FormGroup>
                    )}
                    <Separator />
                    <FormGroup>
                        <label>Mode:</label>
                        <select
                            name="displayMode"
                            value={props.displayMode}
                            onChange={props.handleChange}
                        >
                            {props.displayModes.map(
                                (displayMode, index) =>
                                    displayMode.visible && (
                                        <option
                                            value={displayMode.value}
                                            key={index}
                                        >
                                            {displayMode.name}
                                        </option>
                                    )
                            )}
                        </select>
                    </FormGroup>

                    {(props.displayMode === 'kiosk' ||
                        props.displayMode === 'week') && (
                        <FormGroup>
                            <label>Zoom:</label>
                            <input
                                name="zoom"
                                type="number"
                                step="0.01"
                                value={props.zoom}
                                onChange={props.handleChange}
                            />
                            <div />
                            <small>ex: 1.05</small>
                        </FormGroup>
                    )}
                    {(props.displayMode === 'kiosk' ||
                        props.displayMode === 'week') && (
                        <FormGroup>
                            <label>Print:</label>
                            <div>
                                <Checkbox
                                    name="print"
                                    type="checkbox"
                                    value={props.print}
                                    checked={props.print}
                                    onAction={props.handleChange}
                                />
                            </div>
                        </FormGroup>
                    )}
                    {props.print && props.displayMode !== 'week' && (
                        <>
                            <FormGroup>
                                <label>Orientation:</label>
                                <select
                                    name="orientation"
                                    value={props.orientation}
                                    onChange={props.handleChange}
                                >
                                    <option value="portrait">Portrait</option>
                                    <option value="landscape">Paysage</option>
                                </select>
                            </FormGroup>
                            <FormGroup>
                                <label>Size:</label>
                                <select
                                    name="size"
                                    value={props.size}
                                    onChange={props.handleChange}
                                >
                                    <option value="A4">A4</option>
                                    <option value="A5">A5</option>
                                </select>
                            </FormGroup>
                            <FormGroup>
                                <label>Show date:</label>
                                <div>
                                    <Checkbox
                                        name="showDate"
                                        type="checkbox"
                                        value={props.showDate}
                                        checked={props.showDate}
                                        onAction={props.handleChange}
                                    />
                                </div>
                            </FormGroup>
                        </>
                    )}

                    <ActionLink>
                        <ButtonDiv
                            onClick={e => window.open(props.generateUrl())}
                        >
                            Link
                        </ButtonDiv>
                        {props.displayMode !== 'day' && print && (
                            <ButtonDiv onClick={props.openPrintDialog}>
                                Print
                            </ButtonDiv>
                        )}
                    </ActionLink>
                </>
            )}
            {loading && <Loader small white />}
        </>
    )
}

export default WinrestForm2
